export default "__VITE_ASSET__D0BJMv80__"